import { render, staticRenderFns } from "./DashboardOriginal.vue?vue&type=template&id=7c4fd539&"
import script from "./DashboardOriginal.vue?vue&type=script&lang=js&"
export * from "./DashboardOriginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports